<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="chapterTitle"><a href="#/toc01#chap_09" id="chap09">HOW LONG WOULD IT TAKE TO WALK AROUND THE WORLD?</a></p>
<p class="chapterAuthor">Rosie Swale-Pope</p>
<p class="subhead">who ran around the world</p>
<p class="paraNoIndent">I don’t know how long it would take to walk around the world but it took me 1,789 days to run. I wore out fifty-three pairs of shoes!</p>
<p class="para">I started the run for charity after my husband died, and I am so glad I did. It was amazing. I found out so much about people, and animals, and forests – and about myself.</p>
<p class="para">One of my most unforgettable experiences was meeting a wolf pack in the forest in Siberia. Siberia is the loneliest place on earth. It’s a winter fairyland of beauty and extreme cold.</p>
<p class="para">I was in my tent at night when SUDDENLY I heard a noise. Moments later, a wolf put his head right inside the tent. Great furry paws stretching out in front of his nose, snow melting on his fur so it looked like he was wearing diamonds. Then he just backed away and was gone.</p>
<p class="para">The wolf pack followed me at a distance for ten days, but never came close and didn’t harm me. I remembered that wolves often look after people.</p>
<p class="para">The people I met were pretty special, too. EVERYWHERE. Like the terrifying man in Russia who ran up to me waving an axe, and kindly gave me a parcel of bread! He was a woodsman called Alexei and he thought I must be hungry. Or like the children of White Mountain in Alaska who gave me a beautiful banner they had made before I set off into another thousand miles of wilderness. Their teacher said, ‘We’ve named a star after you. When we look up at the night sky, we’ll be thinking of you!’</p>
<p class="para">At last I made it. All the way round the world. There are two footprints carved into the flagstones of my home in Tenby, Wales. My first step and my last step. There were twenty thousand miles in between.</p>
<p class="para">Thank you for your great question. If you have a dream, whatever it is, GO FOR IT!! I wish you all the good luck in the world!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap09.vue?6a2df886